import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl169ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPraktFile: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    pastApp: yup
      .object()
      .shape({ m02_id: yup.string(), label: yup.string() })
      .nullable()
      .default(undefined)
      .transform((value, originalValue) => {
        if (
          originalValue &&
          typeof originalValue === "object" &&
          Object.keys(originalValue).length === 0
        ) {
          return undefined;
        }
        return value;
      }),
    fudocLoipa: yup.string().nullable(),
    comments: yup.string().nullable(),
  });
};
